export const environment = {
    production: false,
    apiUrl: 'https://api.sample-studio.test.mb-digital-elements.com/api/v1',
    depLogin: 'https://digital-elements.rcps-int.mercedes-benz.com/login',
    depTestLogin: 'https://digital-elements.rcps-int.mercedes-benz.com/login/internal',
    depLogout: 'https://digital-elements.rcps-int.mercedes-benz.com/logout',
    featureFlag: false
};
